import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRightIcon, GiftIcon, ImageIcon, LockOpenIcon, ZapIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { BeeRewardGlyph } from '../components/icons/BeelyvIcons';
import { PostGate } from '../components/PostGate';
import { Card } from '../components/ui/Card';
import { useLocale } from '../contexts/LocaleContext';
import { useProgress } from '../contexts/ProgressContext';
export function Create() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const progress = useProgress();
  return <div className="px-2 pb-2" data-id="element-2242" data-mp="lbhbkzdsc9ad">
      <PageHeader title={t('create.title')} subtitle={t('create.subtitle')} showBack data-id="element-2243" data-mp="lbr4ovu4mwka" />

      <Card className="p-2" data-id="element-2244" data-mp="h79laxroila1">
        <button type="button" onClick={() => navigate('/novo/pulse')} className="flex w-full items-center gap-2 text-left" data-id="element-2245" data-mp="hb757lm2zguz">
          <span className="grid h-11 w-11 shrink-0 place-items-center rounded-[14px] bg-deep text-gold" data-id="element-2246" data-mp="1sn81rmp6s9la">
            <ZapIcon size={20} data-id="element-2247" data-mp="5f8cct641y34" />
          </span>
          <span className="min-w-0 flex-1" data-id="element-2248" data-mp="ael15jgjlf8c">
            <span className="block text-section text-deep" data-id="element-2249" data-mp="ad9w7gbd21fn">
              {t('create.pulse.title')}
            </span>
            <span className="mt-[2px] block text-[12px] leading-snug text-muted" data-id="element-2250" data-mp="eebxs3sr2pks">
              {t('create.pulse.body')}
            </span>
            <span className="bee-overline mt-1 block text-[9px] font-bold text-gold-deep" data-id="element-2251" data-mp="3iv6dna8duqg7">
              {t('create.pulse.always')}
            </span>
          </span>
          <ChevronRightIcon size={18} className="shrink-0 text-muted" aria-hidden="true" data-id="element-2252" data-mp="3mtvoav21dtw5" />
        </button>
      </Card>

      <Card className={`mt-2 p-2 ${progress.postUnlocked ? 'border-gold/45' : ''}`} data-id="element-2253" data-mp="gdmj79q799i">
        {progress.postUnlocked ? <button type="button" onClick={() => navigate('/novo/post')} className="flex w-full items-center gap-2 text-left" data-id="element-2254" data-mp="2z7fezp24akkx">
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-[14px] bg-deep text-gold" data-id="element-2255" data-mp="bb09haaymb1a">
              <ImageIcon size={20} data-id="element-2256" data-mp="6cfatfbcvzey" />
            </span>
            <span className="min-w-0 flex-1" data-id="element-2257" data-mp="6bx41or2i2ss">
              <span className="block text-section text-deep" data-id="element-2258" data-mp="k43jf8mec5r6">
                {t('create.post.title')}
              </span>
              <span className="mt-[2px] block text-[12px] leading-snug text-muted" data-id="element-2259" data-mp="g31kkswe5vpq">
                {t('create.post.body')}
              </span>
              <span className="mt-1 flex items-center gap-1 text-[11px] font-medium text-gold-deep" data-id="element-2260" data-mp="3ojmtk9p0wosu">
                {progress.postUnlockSource === 'firstDay' ? <BeeRewardGlyph size={16} aria-hidden="true" data-id="element-2261" data-mp="1engyfr5i384" /> : <LockOpenIcon size={12} aria-hidden="true" data-id="element-2262" data-mp="3sic8i6ppmeel" />}
                {progress.postUnlockSource === 'firstDay' ? t('create.post.firstDay') : t('create.post.unlocked')}
              </span>
              {progress.postUnlockSource === 'firstDay' && <span className="mt-1 block text-[11px] leading-snug text-muted" data-id="element-2263" data-mp="1g8lrtp14dh7w">
                  {t('create.post.firstDayBody', {
              gate: progress.postGateXp
            })}
                </span>}
            </span>
            <ChevronRightIcon size={18} className="shrink-0 text-muted" aria-hidden="true" data-id="element-2264" data-mp="16e3m6ec57blg" />
          </button> : <>
            <div className="flex items-center gap-2" data-id="element-2265" data-mp="1z1g4gcb9sx8y">
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-[14px] bg-sand-deep text-muted" data-id="element-2266" data-mp="2400ytv3ucmph">
                <ImageIcon size={20} data-id="element-2267" data-mp="1pa211tg77daj" />
              </span>
              <div className="min-w-0 flex-1" data-id="element-2268" data-mp="1u9oea2w10tjc">
                <h2 className="text-section text-deep" data-id="element-2269" data-mp="1u8dba5aenpta">{t('create.post.title')}</h2>
                <p className="mt-[2px] text-[12px] leading-snug text-muted" data-id="element-2270" data-mp="2hyhck604fdh4">
                  {t('create.post.body')}
                </p>
              </div>
            </div>
            <div className="mt-2" data-id="element-2271" data-mp="y4xs50a2lowp">
              <PostGate data-id="element-2272" data-mp="y57mf025ei87" />
            </div>
          </>}
      </Card>
    </div>;
}